module.exports = __webpack_public_path__ + "static/img/s116.94c527fe.png";